import { Segmentation, SurveySegment, SurveySegmentation } from "../../DTOs";


// TODO: Clean up and wrap in object

export function getSegmentSelectionKey(cs:SurveySegment)
{
    return `${cs.name}_${cs.value}`;
}

export function getSegmentListKey(csl:SurveySegment[])
{
    sortSegments(csl);
    return csl.map(cs => getSegmentSelectionKey(cs)).join('-');
}


export function surveySegmentCompare(surveySegmentations:SurveySegmentation[], a:SurveySegment, b:SurveySegment)
{
    const aNameIndex = surveySegmentations.findIndex(ss => ss.name === a.name);
    const bNameIndex = surveySegmentations.findIndex(ss => ss.name === b.name);
    if(aNameIndex < bNameIndex) return -1;
    if(aNameIndex > bNameIndex) return 1;

    const aValuesIndex = surveySegmentations[aNameIndex].values.indexOf(a.value);
    const bValuesIndex = surveySegmentations[bNameIndex].values.indexOf(b.value);
    if(aValuesIndex < bValuesIndex) return -1;
    if(aValuesIndex > bValuesIndex) return 1;
    return 0;
}

export function surveySegmentListCompare(surveySegmentations:SurveySegmentation[], a:SurveySegment[], b:SurveySegment[])
{
    if(a.length !== b.length ) return 0;
    if(a.length === 0) return 0;

    for(let i=0; i<a.length; i++){
        const compareValue = surveySegmentCompare(surveySegmentations, a[i], b[i]);
        if(compareValue !== 0)
            return compareValue;
    }

    return 0;
}

export function surveySegmentListCloneSort(surveySegmentations:SurveySegmentation[], csl:SurveySegment[][])
{
    const clonedLists = csl.map(sl => sl.map(s => ({ name:s.name, value:s.value }))); // deep clone
    for(const sl of clonedLists){
        sl.sort((a, b) => surveySegmentCompare(surveySegmentations, a, b));
    }
    return clonedLists.sort((a, b) => surveySegmentListCompare(surveySegmentations, a, b)); 
}


// Use this instead.
// Make sorting an explicit step everywhere

export function getSegmentListKey2(csl:SurveySegment[])
{
    function getSegmentKey(cs:SurveySegment)
    {
        return `${cs.name}$${cs.value}`;
    }

    // Will implicitly sort by name, then value, without modifying original list
    const segmentKeys = csl.map(cs => getSegmentKey(cs));
    return segmentKeys.sort((a,b) => a.localeCompare(b, 'da')).join('|');
}

export function compareSegments(cs1:SurveySegment, cs2:SurveySegment)
{
    return cs1.name.localeCompare(cs2.name, 'da') || cs1.value.localeCompare(cs2.value, 'da');
}

export function sortSegments(csl:SurveySegment[])
{
    csl.sort(compareSegments);
}

// Assumes all SurveySegmentLists contain identical segment names
export function compareSegmentLists(csl1:SurveySegment[], csl2:SurveySegment[]):number
{
    if(csl1.length < csl2.length)
        return -1;
    if(csl2.length < csl1.length)
        return 1;

    sortSegments(csl1);
    sortSegments(csl2);

    for(let i=0; i<csl1.length; i++){
        const compareValue = compareSegments(csl1[i], csl2[i]);
        if(compareValue !== 0)
            return compareValue;
    }
    // All names and values matched
    return 0;
}

// Assumes all SurveySegmentLists contain identical segment names
export function sortSegmentLists(csl:SurveySegment[][])
{
    if(csl.length === 1){
        sortSegments(csl[0]);
        return;
    }

    csl.sort((a, b) => {
        // Just in case
        if(a.length < b.length)
            return -1;
        if(b.length < a.length)
            return 1;
            
        sortSegments(a);
        sortSegments(b);
        for(let i=0; i<a.length; i++){
            if(a[i].name !== b[i].name){
                return a[i].name.localeCompare(b[i].name, 'da');
            }
            else if(a[i].value !== b[i].value){
                return a[i].value.localeCompare(b[i].value, 'da');
            }
        }
        // All names and values matched
        return 0;
    });
}

export function segmentListIsSegmentationMatch(csList:SurveySegment[], filter:Segmentation[]){

    if(filter.length === 0)
        return csList.length === 0;

    for(const fi of filter){
        const selection = csList.find(cs => cs.name === fi.name);
        if(selection === undefined)
            throw new Error(`No segment named: ${fi.name} in list being filtered`);

        
        // Attempt to find selections value in corresponding filter values
        if(fi.values.find(fiv => fiv === selection.value) === undefined)
            return false;
    }
    return true;
}

export function segmentListIsInLists(lists:SurveySegment[][], list:SurveySegment[]){

    // if no segments are defined, an empty list is a match
    if(list.length === 0 && lists.length === 0)
        return true;

    // otherwise, it is not
    if(lists.length === 0 || list.length === 0)
        return false;

    for(const l of lists){
        if(segmentListsMatch(l, list))
            return true;
    }
    return false;
}

export function segmentListsOfListsMatch(lhs:SurveySegment[][], rhs:SurveySegment[][])
{   
    const lhsClone = lhs.map(x => x.map(y => ({...y}))); // copy
    sortSegmentLists(lhsClone);

    const rhsClone = rhs.map(x => x.map(y => ({...y}))); // copy
    sortSegmentLists(rhsClone);

    return JSON.stringify(lhsClone) === JSON.stringify(rhsClone)
}

export function segmentListsMatch(cs1:SurveySegment[], cs2:SurveySegment[]){
    if(cs1.length !== cs2.length)
        return false;

    for(const cs1i of cs1){
        const hasMatch = cs2.find(cs2i => segmentsMatch(cs1i, cs2i)) != undefined;
        if(!hasMatch)
            return false;
    }
    return true;
}

export function segmentsMatch(cs1:SurveySegment, cs2:SurveySegment){
    return cs1 && cs2 && cs1.name === cs2.name && cs1.value === cs2.value;
}